import { Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getIsTranslationsLoaded } from '../actions/TranslationActions';
import { PENDING_TRANSLATIONS_KEY_LIST } from '../constants/Common';
import { getUITA } from '../utils/commonUtils';
import { isNilOrEmpty } from '../utils/ramdaUtils';

const LazyText = ({ children, text, isAccordion }) => {
  const [isTranslationPending, setIsTranslationPending] = useState(false);
  const isTranslationsLoaded = useSelector(getIsTranslationsLoaded);

  useEffect(() => {
    setIsTranslationPending(PENDING_TRANSLATIONS_KEY_LIST.includes(text));
  }, [text, isTranslationsLoaded]);

  return isTranslationPending && !isNilOrEmpty(text) ? (
    <Skeleton ui-ta={getUITA('LazyText')}>{isAccordion ? <span>{text}</span> : children}</Skeleton>
  ) : (
    children
  );
};

export default LazyText;
